

















import {Vue, Component, Prop, Watch } from 'vue-property-decorator';
@Component
export default class PrioritySelector extends Vue{
    isLow = true;
    isMed = false;
    isHigh = false;
    @Prop() isNullable?: boolean;
    @Prop() priority?: number;

    @Watch('priority')
    onPriorityChanged(nVal: number, oVal: number){
       if(this.priority){
          if(this.priority<5)
            this.select('low');
          else if(this.priority=== 5)
            this.select('med');
          else
            this.select('high');
        }
    }

    select(mode: string){
        if(mode === 'high')
        {
            if(this.isNullable) this.isHigh = !this.isHigh;
            else this.isHigh = true;
            this.isMed = false;
            this.isLow = false;
        }
        else if(mode === 'med'){
            this.isHigh = false;
            if(this.isNullable) this.isMed = !this.isMed;
            else this.isMed = true;
            this.isLow = false;
        }
        else if(mode === 'low'){
            this.isHigh = false;
            this.isMed = false;
            if(this.isNullable) this.isLow = !this.isLow;
            else this.isLow = true;
        }
        if(!this.isMed && !this.isLow && !this.isHigh)
          this.$emit('priority-changed',null);
        else  
          this.$emit('priority-changed',mode);
    }
    clear(){
      this.isLow = false;
      this.isHigh = false;
      this.isMed = false;
    }
    created(){
        if(this.isNullable){
            this.isLow = false;
        }
        if(this.priority){
          if(this.priority<5)
            this.select('low');
          else if(this.priority == 5)
            this.select('med');
          else
            this.select('high');
        }
        
    }
}
